import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Dropdown } from "antd";
import { ItemType } from "antd/es/menu/interface";
import { observer } from "mobx-react-lite";
import React from "react";
import { ProjectFilterItem } from "./ProjectFilterItem";

type Props = {};

export const ProjectOverviewFilter = observer((props: Props) => {
  const t = useTranslation();
  const [openDropdown, setOpenDropdown] = React.useState(false);

  const items: ItemType[] = [
    {
      key: "filterUser",
      label: (
        <ProjectFilterItem
          filterKey="filterUser"
          label={t("maintenance:project.filter.assignedToMe")}
        />
      ),
      style: { cursor: "unset" },
    },
    {
      key: "showFinished",
      label: (
        <ProjectFilterItem
          filterKey="showFinished"
          label={t("maintenance:project.filter.showFinished")}
        />
      ),
      style: { cursor: "unset" },
    },
  ];

  function handleOpenChange(
    open: boolean,
    info: { source: "trigger" | "menu" }
  ) {
    if (info.source === "trigger") {
      setOpenDropdown(open);
    }
  }

  return (
    <Dropdown
      trigger={["click"]}
      open={openDropdown}
      menu={{
        items,
      }}
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      onOpenChange={handleOpenChange}
    >
      <Icon icon="fa:filter" cursor="pointer" />
    </Dropdown>
  );
});
